import { useRef, useState } from 'react'
import classNames from 'classnames'
import { Icon } from '@winnin/winnin_ui.components.icon'

import Popover from 'components/Popover'
import './index.scss'

const { PopoverWrapper, Popover: PopoverContent } = Popover

type ChipsDropdownOption = {
  value: string | number
  label: string
  isDisabled?: boolean
}

interface IChipsDropdown {
  label: string
  onChange: (value: ChipsDropdownOption) => void
  options: ChipsDropdownOption[]
  selected?: ChipsDropdownOption
  disabled?: boolean
  className?: string
  alignment?: 'left' | 'right'
}

export default function ChipsDropdown({
  label,
  onChange,
  options,
  selected,
  disabled,
  className,
  alignment = 'right',
}: IChipsDropdown) {
  const simpleDropdownRef = useRef(null)
  const [open, setOpen] = useState(false)

  function toggle() {
    setOpen(prevState => {
      if (disabled) {
        return false
      }
      return !prevState
    })
  }

  function change(opts) {
    if (opts.isDisabled) return
    onChange?.(opts)
    toggle()
  }

  const selectClass = classNames('selected-value', { opened: open, disabled })
  return (
    <div className={classNames(['ChipsDropdown-wrapper', { active: selected }, className])}>
      <PopoverWrapper popoverElement={simpleDropdownRef.current}>
        <button ref={node => (simpleDropdownRef.current = node)} onClick={toggle} className={selectClass}>
          {selected ? selected?.label : label}
          <Icon className="drop-icon" icon="arrowDown" />
        </button>

        <PopoverContent
          visible={open}
          onVisibleChange={() => {
            if (open) {
              toggle()
            }
          }}
          contentClass={`popover-align-${alignment}`}
        >
          <div className="simple-card-container">
            <ul>
              {options.map(option => {
                const optionClass = classNames('option', {
                  active: selected?.value === option.value,
                  disabled: option.isDisabled,
                })

                return (
                  <li className={optionClass} onClick={() => change(option)} key={option.label}>
                    <span className="simple-dropdown-container-label">{option.label}</span>
                  </li>
                )
              })}
            </ul>
          </div>
        </PopoverContent>
      </PopoverWrapper>
    </div>
  )
}
